import "./App.css";
import LogoBrand from "./assets/images/LogoBrand.png";
import IT from "./assets/images/IT.jpg";
import Computer from "./assets/images/Computer.jpg";
import Phone from "./assets/images/Phone.jpg";
import HeadShot from "./assets/images/HeadShot.jpg";
import Video1 from "./assets/video/man_typing.mp4";
import Video2 from "./assets/video/hardware.mp4";
import Video3 from "./assets/video/hardrive.mp4";

function App() {
  return (
    <div>
      <nav className="navbar navbar-expand-lg">
        <div className="container-fluid">
          <a>
            <img
              src={LogoBrand}
              className="navbar-brand-logo"
              alt="Description"
            />
          </a>
          {/* <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button> */}

          {/* <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <a className="nav-link active" aria-current="page" href="#">
                  About
                </a>
              </li>
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Dropdown
                </a>
                <ul className="dropdown-menu">
                  <li>
                    <a className="dropdown-item" href="#">
                      Action
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="#">
                      Another action
                    </a>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <a className="dropdown-item" href="#">
                      Something else here
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div> */}
        </div>
      </nav>

      <main>
        <div
          id="myCarousel"
          className="carousel slide mb-6"
          data-bs-ride="carousel"
          data-bs-interval="6000"
        >
          <div className="carousel-indicators">
            <button
              type="button"
              data-bs-target="#myCarousel"
              data-bs-slide-to="0"
              className="active"
              aria-current="true"
              aria-label="Slide 1"
            ></button>
            <button
              type="button"
              data-bs-target="#myCarousel"
              data-bs-slide-to="1"
              aria-label="Slide 2"
            ></button>
            <button
              type="button"
              data-bs-target="#myCarousel"
              data-bs-slide-to="2"
              aria-label="Slide 3"
            ></button>
          </div>
          <div className="carousel-inner">
            <div className="carousel-item active">
              <video id="video1" className="w-100 h-100" autoPlay muted loop>
                <source src={Video1} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
              <div className="container">
                <div className="carousel-caption d-flex justify-content-center align-items-center">
                  <h1>Transform Your IT Experience</h1>
                </div>
              </div>
            </div>
            <div className="carousel-item">
              <video id="video2" className="w-100 h-100" autoPlay muted loop>
                <source src={Video2} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
              <div className="container">
                <div className="carousel-caption d-flex justify-content-center align-items-center">
                  <h1>Innovative Solutions for Your Business</h1>
                </div>
              </div>
            </div>
            <div className="carousel-item">
              <video id="video3" className="w-100 h-100" autoPlay muted loop>
                <source src={Video3} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
              <div className="container d-flex justify-content-center align-items-center">
                <div className="carousel-caption ">
                  <h1>Expert Support Every Step of the Way</h1>
                </div>
              </div>
            </div>
          </div>
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#myCarousel"
            data-bs-slide="prev"
          >
            <span
              className="carousel-control-prev-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#myCarousel"
            data-bs-slide="next"
          >
            <span
              className="carousel-control-next-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>

        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="mt-5">
                <h1>About</h1>
                <h6>
                  Pruitt Solutions is a dedicated IT service offering customized
                  technology solutions, including IT consulting, computer
                  repair, tablet and phone repair, and software implementation,
                  to empower customers with efficient and secure operations.
                </h6>
              </div>
            </div>
            <div className="col-md-6">
              <div className="d-flex justify-content-center">
                <svg
                  width="300"
                  height="300"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  {/* Define a clipPath for the rounded rectangle */}
                  <clipPath id="rounded-rect">
                    <rect
                      width="200"
                      height="200"
                      x="50"
                      y="40"
                      rx="100"
                      ry="100"
                    />
                  </clipPath>

                  {/* Use the image and apply the clipPath */}
                  <image
                    href={HeadShot}
                    width="300"
                    height="300"
                    style={{ clipPath: "url(#rounded-rect)" }}
                  />
                </svg>
              </div>
            </div>
          </div>

          <div className="row mt-5 mb-5">
            <div>
              <h1>Services Offered</h1>
            </div>
            <div className="col-md-4 mt-5">
              <div className="card">
                <div className="card-photo">
                  <img src={IT} className="card-img-top" alt="..." />
                </div>
                <div className="card-body">
                  <h5 class="card-title">IT Consulting</h5>
                  <p className="card-text">
                    We provide expert IT consulting services to help businesses
                    optimize their technology infrastructure. From IT strategy
                    and system implementation to improving operational
                    efficiency, we offer tailored solutions to ensure your IT
                    systems align with your business goals.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4 mt-5">
              <div className="card">
                <div className="card-photo">
                  <img src={Computer} className="card-img-top" alt="..." />
                </div>
                <div className="card-body">
                  <h5 class="card-title">Computer Repair</h5>
                  <p className="card-text">
                    We provide reliable computer repair services to fix hardware
                    and software issues, ensuring your devices run smoothly.
                    Whether it's a broken screen, slow performance, or virus
                    removal, our experts offer fast and efficient solutions to
                    get you back up and running.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4 mt-5">
              <div className="card">
                <div className="card-photo">
                  <img src={Phone} className="card-img-top" alt="..." />
                </div>
                <div className="card-body">
                  <h5 class="card-title">Phone Repair</h5>
                  <p className="card-text">
                    We offer professional phone repair services for a wide range
                    of issues, including screen cracks, battery replacements,
                    and software troubleshooting. Our skilled technicians
                    provide fast, reliable repairs to get your phone working
                    like new again.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <footer className="container">
          <p className="float-end">
            <a href="#">Back to top</a>
          </p>
          <p>
            &copy; 2017–2024 Company, Inc. &middot; <a href="#">Privacy</a>{" "}
            &middot; <a href="#">Terms</a>
          </p>
        </footer> */}
      </main>
      <script src="../assets/dist/js/bootstrap.bundle.min.js"></script>
    </div>
  );
}

export default App;
